// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationPurchaseDetailsPath = 'M16 70.505L0 56l16-14.505V4h74v91.5l-7.1-5.3a4.7 4.7 0 00-5.5 0l-6.2 4.7-6.3-4.7a4.7 4.7 0 00-5.5 0l-6.2 4.7-6.3-4.7a4.7 4.7 0 00-5.5 0l-6.2 4.7-6.3-4.7a4.7 4.7 0 00-5.5 0L16 95.7V70.505zm7-34.403V11h60v71.7a11.6 11.6 0 00-9.8 1.9l-2.1 1.5-2-1.5a11.6 11.6 0 00-13.9 0l-2.1 1.5-2-1.5a11.6 11.6 0 00-13.9 0l-2.1 1.5-2-1.5A11.9 11.9 0 0023 82.7v-6.824A23.399 23.399 0 0034 78.6a23.4 23.4 0 0015.8-6.1L68 56 54.764 44H66v-7H46.54c-7.13-4.532-16.16-4.832-23.54-.898zM45.1 67.4A16.8 16.8 0 0134 71.6a16.8 16.8 0 01-11.1-4.2L10.4 56l12.5-11.4c6.294-5.722 15.906-5.722 22.2 0L57.6 56 45.1 67.4zM37 23h32v7H37v-7zM23 56c0 6.075 4.925 11 11 11s11-4.925 11-11-4.925-11-11-11-11 4.925-11 11zm7 0a4 4 0 118 0 4 4 0 01-8 0z';
var IllustrationPurchaseDetails = baseIllustration('IllustrationPurchaseDetails', {
  getPath: () => IllustrationPurchaseDetailsPath
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationPurchaseDetails;
//# sourceMappingURL=index.js.map